export const RECIPES_LOADING = "RECIPES_LOADING";
export const RECIPES_FAILED = "RECIPES_FAILED";
export const RECIPES_SUCCESS = "RECIPES_SUCCESS";

export const RECIPE_LOADING = "RECIPE_LOADING";
export const RECIPE_FAILED = "RECIPE_FAILED";
export const RECIPE_SUCCESS = "RECIPE_SUCCESS";

export const MEALS_LOADING = "MEALS_LOADING";
export const MEALS_FAILED = "MEALS_FAILED";
export const MEALS_SUCCESS = "MEALS_SUCCESS";

export const NUTRIENTS_LOADING = "NUTRIENTS_LOADING";
export const NUTRIENTS_FAILED = "NUTRIENTS_FAILED";
export const NUTRIENTS_SUCCESS = "NUTRIENTS_SUCCESS";

export const MYRECIPES_LOADING = "MYRECIPES_LOADING";
export const MYRECIPES_FAILED = "MYRECIPES_FAILED";
export const MYRECIPES_SUCCESS = "MYRECIPES_SUCCESS";

export const MYRECIPES_ADD = "MYRECIPES_ADD";
export const MYRECIPES_DELETE = "MYRECIPES_DELETE";
export const MYRECIPE_FAILED = "MYRECIPE_FAILED";

